import cookie from 'react-cookies';
import * as  CommentsUtils from '../PlayerUI/js/video_comments';
import * as  ticketUtils from '../PlayerUI/js/video_tickets';
import * as  PlayerUtils from '../PlayerUI/js/index';
import * as  GlobalUtils from '../Global/global_js';
import helnix_default_logo from '../../assets/DVTools/images/default_player.jpg';
var load_interval;
export function index_ready(t)
{
    t.toggleBlocking(true);
    var auto_start = GlobalUtils.getParameterByName("as", t);
    //var creator_id = GlobalUtils.getParameterByName("ci", t);
    var player_handler_status = GlobalUtils.getParameterByName("phs", t);

    var download_video_error = "";
    var showDownloadPopup = false;
    if (auto_start) 
    {
        auto_start = (auto_start === "true" ? true : false);
    }
    else
    {
        auto_start = true;
    }
    if (player_handler_status === "nv") 
    {
        download_video_error = "You used all tries to download this video, please buy new token";
        showDownloadPopup = true;
        if (document.getElementById("player-button"))
        {
            document.getElementById("player-button").style.zIndex = 10;
        }
    }
    var helnix_cookie = GlobalUtils.getCookie("helnix_cookies");
    var google_account_info = null;
    if (helnix_cookie !== null && helnix_cookie !== undefined)
    {
        helnix_cookie = convertHelnixCookieToObject(helnix_cookie);
        google_account_info = {
            id: helnix_cookie.account_id,
            account_guid: helnix_cookie.account_guid,
            name: helnix_cookie.firstname + " " + helnix_cookie.lasttname,
            avatar: helnix_default_logo,

        }
    }

    t.setState({
        helnix_cookies: helnix_cookie, google_account_info: google_account_info, auto_start: auto_start,
        download_video_error: download_video_error,
        showDownloadPopup: showDownloadPopup,
        //creator_id: creator_id
    }, () =>
    {
        GlobalUtils.get_api_url(t);
        GlobalUtils.get_stream_link(t);
        GlobalUtils.get_image_server_url(t);
        GlobalUtils.get_player_link(t);
        GlobalUtils.get_pdf_path(t);
        GlobalUtils.get_account_server_url(t);

        load_interval = setInterval(t.loadData, 1000);
    });
    if (window.FB)
    {
        window.FB.XFBML.parse();
    }
    window.fbAsyncInit = function ()
    {
        window.FB.init({
            appId: "1720310068232761",
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v3.0'
        });
    }.bind(this);

    // Load the SDK asynchronously
    (function (d, s, id)
    {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v10.0";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
    const videoGuid = GlobalUtils.getParameterByName("vg", t);
    const videoType = GlobalUtils.getParameterByName("vt", t);
    if (videoGuid && videoType)
    {
        GlobalUtils.get_custom_plan_info(t, videoGuid, videoType);
    }
}
export function loadData(t)
{
    if (localStorage.getItem("api_url") !== null && localStorage.getItem("get_image_server_url") !== null
        && localStorage.getItem("get_player_link") !== null && localStorage.getItem("get_pdf_path") !== null
        && localStorage.getItem("get_stream_link") !== null)
    {
        clearInterval(load_interval);

        const videoGuid = GlobalUtils.getParameterByName("vg", t);
        const videoType = GlobalUtils.getParameterByName("vt", t);
        const channelGuid = GlobalUtils.getParameterByName("ch", t);
        const video_token = GlobalUtils.getParameterByName("td", t);
        const helnix_account_guid = GlobalUtils.getParameterByName("hacg", t);
        const video_donation_transaction = GlobalUtils.getParameterByName("ppt", t);    
        var userGuid = "";
        if (helnix_account_guid && (document.referrer.indexOf("ottmediaservice.com") > -1)
            || document.referrer.indexOf("linearbroadcast.com") >-1
            || document.referrer.indexOf("ottmediaservice.me") > -1 )
        {
            userGuid = helnix_account_guid;
        }
        else if (t.state.helnix_cookies !== null && t.state.helnix_cookies !== undefined)
        {
            userGuid = t.state.helnix_cookies.account_guid;
        }
        else
        {
            userGuid = "";
        }
        //(t.state.helnix_cookies !== null && t.state.helnix_cookies !== undefined) ? :
        //    helnix_account_guid !== null ? helnix_account_guid : "";
        localStorage.setItem("error_info", "account_guid=" + userGuid);
        cookie.save("error_info", "account_guid=" + userGuid);
        const is_embed = window.location.href.indexOf("Embed") > -1 ? true : false;
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                videoGuid: videoGuid,
                videoType: videoType,
                channelGuid: channelGuid,
                userGuid: userGuid,
                //video_token: video_token
                new_ticket: video_token,
                video_donation_transaction: video_donation_transaction
            },
            userGuid: userGuid,
            is_embed: is_embed,
            dimensions: {
                width: window.innerWidth * .71,
            },
        }), () =>
        {
            if (videoGuid !== "" && videoType !== "")
            {
                if (video_donation_transaction)
                {
                    t.setState({ showDonatePopup: true })
                }
                PlayerUtils.documnetReady(t);
            }
            else
            {
                t.toggleBlocking(false);
            }

            if (video_token !== "" && video_token !== null && video_token !== undefined)
            {
                ticketUtils.load_ticket_order_info(t);
            }
        })
    }
}
export function onSuccessresponseGoogle(t, response)
{
    if (response.profileObj !== null && response.profileObj !== undefined)
    {
        var google_account_info = {
            email: response.profileObj.email,
            last_name: response.profileObj.familyName, first_name: response.profileObj.givenName,
            name: response.profileObj.givenName + " " + response.profileObj.familyName,
            id: response.profileObj.email,
        };
        //document.cookie = "google_Acount_info" + "=email=" + response.profileObj.email +
        //    "&last_name=" + response.profileObj.familyName + "&first_name=" + response.profileObj.givenName
        //    +"name";

        document.cookie = "google_Acount_info" + "=" + JSON.stringify(google_account_info);
        t.setState({
            google_account_info: {
                email: response.profileObj.email,
                last_name: response.profileObj.familyName, first_name: response.profileObj.givenName,
                name: response.profileObj.givenName + " " + response.profileObj.familyName,
                id: response.profileObj.email,
            },
            showLoginCustomAlert: false,
        }, () =>
        {

            CommentsUtils.add_new_comment(t, 13, false);
        })
    }
}
export function onChatSuccessresponseGoogle(t, response)
{
    if (response.profileObj !== null && response.profileObj !== undefined)
    {
        t.setState({
            google_account_info: {
                email: response.profileObj.email,
                last_name: response.profileObj.familyName, first_name: response.profileObj.givenName,
                account_guid: response.profileObj.email,
                name: response.profileObj.givenName + " " + response.profileObj.familyName,
                id: response.profileObj.email,
            },
            showChatLoginCustomAlert: false,
        }, () =>
        {
            t.setState(prevState => ({
                messageEvent: {
                    ...prevState.messageEvent,
                    author: { id: response.profileObj.email, name: response.profileObj.givenName + " " + response.profileObj.familyName, avatarUrl: "" }
                }
            }), () =>
            {
                //liveChatUtils.add_new_chat(t.state.rightComponent, t.state.messageEvent);
            })

        })
    }
}

export function onCancelLogin(t)
{
    t.setState({ showLoginCustomAlert: false });
}
export function onCancelChatLogin(t)
{
    t.setState({ showChatLoginCustomAlert: false });
}

export function onEditCommentClick(t, comment_guid)
{
    var all_comments = t.state.videoData.video_comments;
    var for_edit_comments = t.state.for_edit_comments;
    for (var i = 0; i < all_comments.length; i++)
    {
        if (all_comments[i].comment_guid === comment_guid)
        {
            for_edit_comments.push({ comment_guid: all_comments[i].comment_guid, comment: all_comments[i].comment, account_guid: all_comments[i].account_guid });
            all_comments[i].showEditInput = true;
            break;
        }
    }
    t.setState(prevState => ({
        videoData: {
            ...prevState.videoData,
            video_comments: all_comments
        },
        for_edit_comments: for_edit_comments,
    }))
}
export function onCommentKeyUp(t, e, item)
{
    if (e.keyCode === 27 && !e.shiftKey)//close edit comment
    {
        var all_comments = t.state.videoData.video_comments;
        var old_comment = t.state.for_edit_comments.filter(a => a.comment_guid === item.comment_guid)
        for (var i = 0; i < all_comments.length; i++)
        {
            if (all_comments[i].comment_guid === item.comment_guid)
            {
                all_comments[i].showEditInput = false;
                all_comments[i].comment = old_comment[0].comment;
                break;
            }
        }
        var old_comment_after_remove = t.state.for_edit_comments.filter(a => a.comment_guid !== item.comment_guid)
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                video_comments: all_comments
            },
            for_edit_comments: old_comment_after_remove
        }))
    }
    else if (e.keyCode === 13 && !e.shiftKey)
    {
        CommentsUtils.save_edit_comment(t, item);
    }
}
export function onCommentValueChanged(t, e, item)
{
    var all_comments = t.state.videoData.video_comments;
    var comment = "";
    for (var i = 0; i < all_comments.length; i++)
    {
        if (all_comments[i].comment_guid === item.comment_guid)
        {

            all_comments[i].comment = e.currentTarget.value;
            break;
        }
    }
    t.setState(prevState => ({
        videoData: {
            ...prevState.videoData,
            video_comments: all_comments
        }
    }))
}
export function cancelCommentChange(t, item, isChanged)
{
    if (isChanged === true)
    {
        var all_comments = t.state.videoData.video_comments;
        for (var i = 0; i < all_comments.length; i++)
        {
            if (all_comments[i].comment_guid === item.comment_guid)
            {
                all_comments[i].showEditInput = false;
                break;
            }
        }
        var old_comment_after_remove = t.state.for_edit_comments.filter(a => a.comment_guid !== item.comment_guid)
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                video_comments: all_comments
            },
            for_edit_comments: old_comment_after_remove,
        }))
    }
    else
    {
        var all_comments = t.state.videoData.video_comments;
        var old_comment = t.state.for_edit_comments.filter(a => a.comment_guid === item.comment_guid)
        for (var i = 0; i < all_comments.length; i++)
        {
            if (all_comments[i].comment_guid === item.comment_guid)
            {
                all_comments[i].showEditInput = false;
                all_comments[i].comment = old_comment[0].comment;
                break;
            }
        }
        var old_comment_after_remove = t.state.for_edit_comments.filter(a => a.comment_guid !== item.comment_guid)
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                video_comments: all_comments
            },
            for_edit_comments: old_comment_after_remove,
        }))
    }
}
export function convertHelnixCookieToObject(helnix_cookies)
{
    var all_cookies = helnix_cookies.split("&")
    var result = { account_guid: "", product_id: 0, };
    for (var i = 0; i < all_cookies.length; i++)
    {
        if (all_cookies[i].indexOf("account_guid") > -1)
        {
            result.account_guid = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("product_id") > -1)
        {
            result.product_id = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("account_id") > -1)
        {
            result.account_id = all_cookies[i].split("=")[1];
        }

        if (all_cookies[i].indexOf("firstname") > -1)
        {
            result.firstname = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("lasttname") > -1)
        {
            result.lasttname = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("lasttname") > -1)
        {
            result.lasttname = all_cookies[i].split("=")[1];
        }

    }
    return result;
}

